var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { forwardRef, useContext } from 'react';
import { Button as ArcoButton, ConfigProvider } from '@arco-design/web-react';
import { useConfigContext } from '@m4b-design/config-provider';
import cx from 'classnames';
import './style/button.less';
var ButtonRender = function ButtonRender(props, ref) {
  var _a;
  var _b = useConfigContext(),
    globalPrefixCls = _b.prefixCls,
    rtl = _b.rtl;
  var suffixIcon = props.suffixIcon,
    _c = props.size,
    size = _c === void 0 ? 'default' : _c,
    restProps = __rest(props, ["suffixIcon", "size"]);
  var getPrefixCls = useContext(ConfigProvider.ConfigContext).getPrefixCls;
  var arcoBtnPrefixCls = getPrefixCls('btn');
  var type = props.type;
  var extClassName;
  var prefixCls = "".concat(globalPrefixCls, "-button");
  if (type === 'primary-text') {
    type = 'text';
    extClassName = "".concat(arcoBtnPrefixCls, "-primary-text");
  }
  if (type === 'dark-outline') {
    type = 'outline';
    extClassName = "".concat(prefixCls, "-dark-outline");
  }
  if (type === 'dark-primary') {
    type = 'primary';
    extClassName = "".concat(prefixCls, "-dark-primary");
  }
  if (type === 'link') {
    type = 'primary';
    extClassName = "".concat(prefixCls, "-link");
  }
  if (type === 'grey-link') {
    type = 'primary';
    extClassName = "".concat(prefixCls, "-grey-link");
  }
  var handleClick = function handleClick(e) {
    var _a;
    (_a = props === null || props === void 0 ? void 0 : props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
  };
  return /*#__PURE__*/React.createElement(ArcoButton, __assign({
    "data-tid": "m4b_button"
  }, restProps, {
    type: type,
    onClick: handleClick,
    className: cx(prefixCls, "".concat(prefixCls, "-size-").concat(size), props.className, extClassName, (_a = {}, _a["".concat(prefixCls, "-rtl")] = rtl, _a)),
    ref: ref,
    size: size === 'abnormal' ? 'large' : size
  }), suffixIcon ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(globalPrefixCls, "-button-icon")
  }, props.children, suffixIcon && /*#__PURE__*/React.createElement("span", {
    className: "".concat(globalPrefixCls, "-button-icon-suffix")
  }, suffixIcon)) : props.children);
};
var Button = /*#__PURE__*/forwardRef(ButtonRender);
Button.displayName = 'Button';
export default Button;